import type { MessageThreadReportRequest } from 'src/types/report';

import { APIClientType } from '.';

export interface ReportServiceType {
  reportMessageThread: (request: MessageThreadReportRequest) => Promise<void>;
}

export class ReportService implements ReportServiceType {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public reportMessageThread = async (request: MessageThreadReportRequest) => {
    return this.client.call<void, Parameters<typeof this.reportMessageThread>>({
      method: 'reportMessageThread',
      data: [request],
    });
  };
}
